<template>
  <component :is="componentId" @home="setHome" @login="setLogin"></component>
</template>

<script>
import Home from "./Home";
import Login from "./Login";
export default {
  data: () => ({
    componentId: Login
  }),
  mounted() {
    if (sessionStorage.getItem("logado") === "true") {
      this.componentId = Home;
    }
  },
  methods: {
    setHome(val) {
      this.componentId = val;
    },
    setLogin(val) {
      this.componentId = val;
    }
  }
};
</script>
